import { render, staticRenderFns } from "./details-subscription.vue?vue&type=template&id=6ee5a5fa&"
import script from "./details-subscription.vue?vue&type=script&lang=ts&"
export * from "./details-subscription.vue?vue&type=script&lang=ts&"
import style0 from "./details-subscription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports